module.exports = __webpack_public_path__ + "img/icon_delivered.83bd54d3.svg";